import React from 'react';
import { Button, Text } from '@fluentui/react-components';
import successIcon from '../../assets/onboarding-success-icon.png';
import { useStyles } from './OnboardingOutcome.styles';

export const OnboardingSuccessPage: React.FC = () => {
  const styles = useStyles();

  return (
    <main className={styles.outcomePage} data-testid="onboarding-success-page">
      <section className={`${styles.outcomeCard} ${styles.successCard}`} data-testid="onboarding-success-content">
        <img src={successIcon} alt="" className={styles.successIcon} />
        <Text as="h1" className={styles.successTitle} data-testid="onboarding-success-title">
          Disclaimers are enabled
        </Text>
        <Text as="p" className={styles.successDescription} data-testid="onboarding-success-description">
          Disclaimers now appear automatically in Microsoft Teams conversations, based on your organisation's policies.
        </Text>
        <Button
          as="a"
          href="https://teams.microsoft.com/l/app/172f480b-07cc-499d-8644-1ffc5b2694bb?source=store-item"
          target="_blank"
          rel="noopener noreferrer"
          appearance="primary"
          size="small"
          className={styles.successButton}
          data-testid="onboarding-success-teams-link"
        >
          Open Workspace in Teams
        </Button>
      </section>
    </main>
  );
};
